const Joi = require("joi");
const ValidationTranslateFile = require("../Loc/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const MyProfileSchema = (data) => {
    const schema = Joi.object({
        newAnswer: Joi.string()
            .trim()
            .required()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Enter_Answer,
                "any.required": currentLang?.ValidationSchema?.Enter_Answer,
            }),

    }).unknown(true); // Allow unknown properties in the data if necessary

    return schema.validate(data, {
        abortEarly: false, // Will return all errors, not just the first one
    });
};

module.exports = MyProfileSchema;
